import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import { getAssessment } from '../services/assessmentService';

export const useCouple = () => {
  const { currentUser, userProfile } = useAuth();
  const [couple, setCouple] = useState(null);
  const [partnerAssessment, setPartnerAssessment] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadCoupleData = async () => {
      try {
        console.log('useCouple: Starting...');
        console.log('useCouple: userProfile:', userProfile);
        
        if (!userProfile?.coupleId) {
          console.log('useCouple: No coupleId found');
          setLoading(false);
          return;
        }

        // Get couple data directly from Firestore
        console.log('useCouple: Getting couple:', userProfile.coupleId);
        const coupleDoc = await getDoc(doc(db, 'couples', userProfile.coupleId));
        
        if (!coupleDoc.exists()) {
          console.log('useCouple: Couple document not found');
          setCouple(null);
          setLoading(false);
          return;
        }

        const coupleData = { id: coupleDoc.id, ...coupleDoc.data() };
        console.log('useCouple: Couple data found:', coupleData);
        setCouple(coupleData);

        // Determine partner ID
        const partnerId = currentUser.uid === coupleData.partner1Id 
          ? coupleData.partner2Id 
          : coupleData.partner1Id;

        console.log('useCouple: Getting partner assessment:', partnerId);
        
        const partnerResult = await getAssessment(partnerId);
        console.log('useCouple: Partner assessment result:', partnerResult);

        // ✅ FIX: Extract actual data from wrapped result
        if (partnerResult?.success && partnerResult?.data) {
          console.log('useCouple: Setting partner data:', partnerResult.data);
          setPartnerAssessment(partnerResult.data);
        } else {
          console.log('useCouple: No partner assessment found');
          setPartnerAssessment(null);
        }

        console.log('useCouple: ✅ Complete');
        setLoading(false);
      } catch (error) {
        console.error('useCouple: ❌ Error:', error);
        setLoading(false);
      }
    };

    if (currentUser && userProfile) {
      loadCoupleData();
    } else {
      console.log('useCouple: No user/profile, setting loading false');
      setLoading(false);
    }
  }, [currentUser, userProfile]);

  return { couple, partnerAssessment, loading };
};